var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 192,
    viewBox: "0 0 255 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249 0.5H6C2.96243 0.5 0.5 2.96243 0.5 6V186C0.5 189.038 2.96243 191.5 6 191.5H249C252.038 191.5 254.5 189.038 254.5 186V6C254.5 2.96243 252.038 0.5 249 0.5Z",
    stroke: "#718095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239 32H16C13.7909 32 12 33.7909 12 36V177C12 179.209 13.7909 181 16 181H239C241.209 181 243 179.209 243 177V36C243 33.7909 241.209 32 239 32Z",
    fill: "#718095",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H13C11.3431 12 10 13.3431 10 15V20C10 21.6569 11.3431 23 13 23H18C19.6569 23 21 21.6569 21 20V15C21 13.3431 19.6569 12 18 12Z",
    fill: "#D1D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 15H27.5C26.1193 15 25 16.1193 25 17.5C25 18.8807 26.1193 20 27.5 20H48.5C49.8807 20 51 18.8807 51 17.5C51 16.1193 49.8807 15 48.5 15Z",
    fill: "#718095"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 16H178.5C177.672 16 177 16.6716 177 17.5C177 18.3284 177.672 19 178.5 19H198.5C199.328 19 200 18.3284 200 17.5C200 16.6716 199.328 16 198.5 16Z",
    fill: "#4B5563"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 16H110.5C109.672 16 109 16.6716 109 17.5C109 18.3284 109.672 19 110.5 19H130.5C131.328 19 132 18.3284 132 17.5C132 16.6716 131.328 16 130.5 16Z",
    fill: "#4B5563"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 16H144.5C143.672 16 143 16.6716 143 17.5C143 18.3284 143.672 19 144.5 19H164.5C165.328 19 166 18.3284 166 17.5C166 16.6716 165.328 16 164.5 16Z",
    fill: "#4B5563"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 12H214.5C211.462 12 209 14.4624 209 17.5C209 20.5376 211.462 23 214.5 23H238.5C241.538 23 244 20.5376 244 17.5C244 14.4624 241.538 12 238.5 12Z",
    fill: "#D1D5DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 16H216.5C215.672 16 215 16.6716 215 17.5C215 18.3284 215.672 19 216.5 19H236.5C237.328 19 238 18.3284 238 17.5C238 16.6716 237.328 16 236.5 16Z",
    fill: "#4B5563"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSection);
export default __webpack_public_path__ + "static/media/hero-section.f10b2929532b9317c3d27f0f08aefc02.svg";
export { ForwardRef as ReactComponent };